import * as actions_invoices from 'actions/invoices-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import { APPS, INVOICES, SERVICE_REQUEST_TERMS } from 'components/constants';
import { Ibox, ModalAlert } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { numPanels, navMultipleUrls } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';

var _ = require('lodash');

export default function InvoicesTab(props) {
    
    /* Hooks ------------------------------------------------------------------------------------------------------------------------------------*/
    
    const seg = 9
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();
    const routeLocation = useLocation();

    // const quickbooksSettings = useSelector((store) => store.quickbooks.quickbooks);
    const assets = useSelector((store) => store.assets.assets);
    const invoices = useSelector((store) => store.invoices);
    const serviceRequest = useSelector((store) => store.serviceRequests.service_request);;
    const settings = useSelector((store) => store.settings);
    const table = useSelector((store) => store[props.store]);
    const user = useSelector((store) => store.users.user);

    const [timer, setTimer] = useState(null);
    const [canAuto, setCanAuto] = useState(true);

    const fromAssetDashboard = props.source == 'customers';
    const invoicesList = table?.[props.singular + '_invoices'] ?? [];

    /* Effects ------------------------------------------------------------------------------------------------------------------------------------*/

    // Subscribe to Invoices based on different fields
    useEffect(() => {

        let field, id;
        switch(props.source) {
            case 'assets' : field = 'assetId'; id = params.asset_id; break;
            case 'service-requests' : field = 'requestId'; id = params.request_id; break;
            case 'profiles' : field = 'customerId'; id = params.customer_id; break;
        }
        dispatch(actions_invoices.subInvoicesByField(params.handle, field, id, props.prefix));

        return () => {
			const unsubscribe = table[props.singular + '_invoices_unsubscribe'];
            if (typeof unsubscribe === 'function') unsubscribe();
        };
    }, [params.asset_id, params.request_id, params.customer_id]);

    useEffect(() => { setCanAuto(true); }, [params.tab]);

    // Automatically advance to the first item
    useEffect(() => {
        if (
            numPanels(3) && canAuto &&
            props.source == 'service-requests' &&
            params.tab == 'invoices' && 
            invoicesList?.length && 
            !params.invoice_id
        ) {
            if (timer) clearTimeout(timer);
            setTimer(setTimeout(() => {
                let location = toolbox.modifyPath(routeLocation.pathname, seg, `invoices/preview/${invoicesList[0]?.id}`);
                props.history.push({ pathname: location });
            }, 300));
        }
        setTimeout(() => { setCanAuto(false) }, 2000);
    }, [params.tab, invoicesList]);

    /* Handlers/Actions ------------------------------------------------------------------------------------------------------------------------------------*/
 
    const handleClick = (invoice) => {
        const changeHistory = (routeLocation.pathname.includes('preview'))
            ? history.replace
            : history.push;

        switch(props.source) {
            case 'assets' :
                var location = toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests/${invoice.requestId}/invoices/preview/${invoice.id}`);
                changeHistory({ pathname: location });
                break;
            case 'service-requests' :               
                let startSegment = (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) ? seg+3 : seg+1;
                var location = toolbox.modifyPath(routeLocation.pathname, startSegment, `preview/${invoice.id}`);
                changeHistory({ pathname: location });
                break;
            case 'profiles' :
                if (params.appId == APPS.DISPATCH.id) {
                    navMultipleUrls({ actions_users, dispatch, history, numPanels, params, replace: true, user, urlArray: [
                        toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests`, seg-2),
                        toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests/${invoice.requestId}/invoices`),
                        toolbox.modifyPath(routeLocation.pathname, seg-2, `service_requests/${invoice.requestId}/invoices/preview/${invoice.id}`),
                    ]});
                } else if (params.appId == APPS.ASSETS.id) {
                    var asset = _.find(assets, (a) => { return a.id == invoice.assetId})
                    if (asset) navMultipleUrls({ actions_users, dispatch, history, numPanels, params, replace: true, user, urlArray: [
                        toolbox.modifyPath(routeLocation.pathname, seg-6, `assets/${asset.id}/form/0/service_requests`),
                        toolbox.modifyPath(routeLocation.pathname, seg-6, `assets/${asset.id}/form/0/service_requests/${invoice.requestId}/invoices`),
                        toolbox.modifyPath(routeLocation.pathname, seg-6, `assets/${asset.id}/form/0/service_requests/${invoice.requestId}/invoices/preview/${invoice.id}`),
                    ]});
                }
                break;
        }
    };

    /* Constants ------------------------------------------------------------------------------------------------------------------------------------*/

    const redistWidth = 30;
    const redist = (num) => (numPanels() > 1) ? num : num + (num / (100 - redistWidth) * (redistWidth));
    const columns = [
        { name: 'ID', field: 'id', nowrap: true, width: redist(10) },
        { name: 'Created', field: 'created', type: 'date', format: 'MMM Do, YYYY', width: redist(30) },
        { name: 'Memo', field: 'memo', ...(!numPanels(1)) ? { width: 30 } : {} },
        { name: 'Total', field: 'originalBalance', type: 'number', format: 'usd', text_align: 'right', width: redist(15) },
        { name: 'Balance', field: 'openBalance', type: 'number', format: 'usd', text_align: 'right', width: redist(15) },
    ];

    const data = invoicesList?.map((invoice) => {
        let paymentsTotal = invoice.payments?.reduce((total, p) => total + (p.amount ?? 0), 0) ?? 0;
        
        return ({ ...invoice,
            originalBalance: invoice.totals?.grandTotal ?? 0,
            openBalance: ((invoice.totals?.grandTotal ?? 0) - paymentsTotal),
            _stripe_color: Object.values(INVOICES).find((item) => item.id == invoice.statusId)?.color
        });
    });

    const statusStyle = { position: 'absolute', top: '-36px', left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' };

    /* Render ------------------------------------------------------------------------------------------------------------------------------------*/

    return (

        <Ibox className="" title={'Invoices'} show_spinner={invoices.invoices_pending} no_fade={false}>
            <Table
                active_field={'id'}
                active_id={params.invoice_id}
                chevron={true}
                click_callback={handleClick}
                columns={columns}
                data={data}
                highlight_search={true}
                id="invoices-tab"
                max_height={'135px'}
                second_line={(numPanels(1)) ? 'memo' : ''}
                second_line_prefix={<i className="fa-solid fa-circle-arrow-right fa-lg mr-1"></i>}
                show_limit={false}
                show_search={true}
            />
        </Ibox>

    );
};